import React from "react";
import "../CSS/styles.css";
import { Link } from 'react-router-dom';

const How = () => {
  return (
    <div className="container py-5">
      <div className="row">
        <h1 className="text-center fw-bold mb-0 bc">How We Can Help</h1>
        <p className="text-center mb-0 mt-3 gc2">TAMBRO offers a wide range of services designed to address the complex </p>
        <p className="text-center mb-0 gc2">challenges faced by organizations in today's rapidly evolving landscape.</p>
        <div className="col-lg-6 col-12 p-3 mt-5">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M39.9824 25.9859C39.9824 35.9834 32.9841 40.9822 24.6662 43.8815C24.2306 44.0291 23.7575 44.0221 23.3265 43.8615C14.9885 40.9822 7.99023 35.9834 7.99023 25.9859V11.9893C7.99023 11.459 8.2009 10.9504 8.57588 10.5754C8.95086 10.2005 9.45944 9.98979 9.98975 9.98979C13.9888 9.98979 18.9875 7.59038 22.4667 4.55112C22.8903 4.1892 23.4292 3.99036 23.9863 3.99036C24.5435 3.99036 25.0824 4.1892 25.506 4.55112C29.0051 7.61037 33.9839 9.98979 37.9829 9.98979C38.5132 9.98979 39.0218 10.2005 39.3968 10.5754C39.7718 10.9504 39.9824 11.459 39.9824 11.9893V25.9859Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">Risk Management</h3>
            <p className="mb-0 mt-3 gc2">Comprehensive risk assessment and mitigation strategies to protect your assets and operations. We identify potential threats, analyze vulnerabilities, and develop tailored solutions to minimize risks. </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Risk assessment and analysis</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Security audits and evaluations</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Risk mitigation planning</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Threat monitoring and intelligence</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Vulnerability management</p>
            </div>
            <Link to="/Risk" className="text-decoration-none">
              <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
                <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
                <div>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="col-lg-6 col-12 p-3 mt-lg-5 mt-3">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M44.4375 35.9834L28.4414 7.99019C28.0926 7.37475 27.5868 6.86284 26.9756 6.50669C26.3644 6.15054 25.6697 5.96289 24.9623 5.96289C24.2549 5.96289 23.5601 6.15054 22.9489 6.50669C22.3377 6.86284 21.8319 7.37475 21.4831 7.99019L5.48703 35.9834C5.13448 36.5939 4.94962 37.2868 4.95118 37.9919C4.95274 38.6969 5.14067 39.389 5.49592 39.998C5.85117 40.607 6.36112 41.1113 6.97406 41.4597C7.58701 41.8081 8.28117 41.9882 8.98618 41.9819H40.9784C41.68 41.9812 42.3691 41.7959 42.9764 41.4446C43.5838 41.0933 44.088 40.5884 44.4385 39.9806C44.789 39.3728 44.9735 38.6835 44.9733 37.9818C44.9731 37.2802 44.7883 36.591 44.4375 35.9834Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24.9824 17.9878V25.9858" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24.9824 33.9839H25.0024" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">Crisis Management</h3>
            <p className="mb-0 mt-3 gc2">Rapid response solutions and preparedness planning for critical situations. Our crisis management services help organizations prepare for, respond to, and recover from emergencies and critical incidents. </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Crisis response planning</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Emergency management protocols</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Crisis simulation exercises</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">24/7 incident response support</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Post-crisis recovery planning</p>
            </div>
            <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
              <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 p-3 mt-lg-0 mt-3">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29.9849 3.99121H11.9893C10.9287 3.99121 9.91148 4.41254 9.16152 5.1625C8.41156 5.91246 7.99023 6.92963 7.99023 7.99023V39.9824C7.99023 41.043 8.41156 42.0602 9.16152 42.8102C9.91148 43.5601 10.9287 43.9814 11.9893 43.9814H35.9834C37.044 43.9814 38.0612 43.5601 38.8111 42.8102C39.5611 42.0602 39.9824 41.043 39.9824 39.9824V13.9888L29.9849 3.99121Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.9854 3.99121V11.9893C27.9854 13.0499 28.4067 14.067 29.1566 14.817C29.9066 15.567 30.9238 15.9883 31.9844 15.9883H39.9824" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.9883 17.9878H15.9883" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M31.9844 25.9858H15.9883" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M31.9844 33.9839H15.9883" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">Project Support</h3>
            <p className="mb-0 mt-3 gc2">End-to-end project management and technical assistance for complex initiatives. We provide the expertise and resources needed to ensure successful project execution and delivery. </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Project planning and strategy</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Resource allocation and management</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Progress monitoring and reporting</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Risk and issue management</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Quality assurance</p>
            </div>
            <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
              <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 p-3 mt-lg-0 mt-3">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M42.9782 42.7124L34.3003 34.0345" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22.9829 38.7134C31.8173 38.7134 38.979 31.5517 38.979 22.7173C38.979 13.8829 31.8173 6.72119 22.9829 6.72119C14.1485 6.72119 6.98682 13.8829 6.98682 22.7173C6.98682 31.5517 14.1485 38.7134 22.9829 38.7134Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">Research & Analysis</h3>
            <p className="mb-0 mt-3 gc2">Data-driven insights and strategic intelligence to inform decisionmaking. Our research team conducts thorough analysis to provide actionable recommendations for your organization. </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Market and industry research</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Competitive intelligence</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Data analysis and visualization</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Trend forecasting</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Strategic recommendations</p>
            </div>
            <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
              <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 p-3 mt-lg-0 mt-3">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.9824 44.4424C36.0254 44.4424 44.9775 35.4903 44.9775 24.4473C44.9775 13.4043 36.0254 4.45215 24.9824 4.45215C13.9394 4.45215 4.9873 13.4043 4.9873 24.4473C4.9873 35.4903 13.9394 44.4424 24.9824 44.4424Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24.9824 4.45215C19.8481 9.84314 16.9844 17.0026 16.9844 24.4473C16.9844 31.892 19.8481 39.0514 24.9824 44.4424C30.1167 39.0514 32.9805 31.892 32.9805 24.4473C32.9805 17.0026 30.1167 9.84314 24.9824 4.45215Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M4.9873 24.4473H44.9775" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">GIS</h3>
            <p className="mb-0 mt-3 gc2">Geographic Information Systems for spatial analysis and visualization. Our GIS services help organizations leverage location-based data for better decision-making and planning.  </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Spatial data analysis</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Custom map creation</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Geospatial modeling</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Remote sensing</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Location intelligence</p>
            </div>
            <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
              <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 p-3 mt-lg-0 mt-3">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M38.979 22.4478H10.9858C8.77724 22.4478 6.98682 24.2382 6.98682 26.4468V40.4434C6.98682 42.652 8.77724 44.4424 10.9858 44.4424H38.979C41.1876 44.4424 42.978 42.652 42.978 40.4434V26.4468C42.978 24.2382 41.1876 22.4478 38.979 22.4478Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14.9849 22.4478V14.4497C14.9849 11.7982 16.0382 9.25527 17.9131 7.38037C19.788 5.50546 22.3309 4.45215 24.9824 4.45215C27.6339 4.45215 30.1769 5.50546 32.0518 7.38037C33.9267 9.25527 34.98 11.7982 34.98 14.4497V22.4478" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">Cyber Security</h3>
            <p className="mb-0 mt-3 gc2">Advanced protection against digital threats and vulnerabilities. Our cyber security experts implement robust measures to safeguard your digital assets and information systems. </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Security assessments and audits</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Penetration testing</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Security monitoring and incident response</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Security awareness training</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Compliance and governance</p>
            </div>
            <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
              <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 p-3 mt-lg-0 mt-3">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M43.8179 22.0223C44.1759 21.8644 44.4796 21.6049 44.6916 21.2761C44.9035 20.9472 45.0143 20.5634 45.0103 20.1722C45.0062 19.781 44.8875 19.3996 44.6688 19.0752C44.4501 18.7508 44.141 18.4976 43.7799 18.3472L26.6421 10.5411C26.1211 10.3034 25.5551 10.1805 24.9825 10.1805C24.4099 10.1805 23.8439 10.3034 23.3229 10.5411L6.1871 18.3392C5.83112 18.4951 5.52829 18.7513 5.31564 19.0766C5.10299 19.4019 4.98975 19.7821 4.98975 20.1707C4.98975 20.5593 5.10299 20.9395 5.31564 21.2648C5.52829 21.5901 5.83112 21.8464 6.1871 22.0023L23.3229 29.8164C23.8439 30.054 24.4099 30.177 24.9825 30.177C25.5551 30.177 26.1211 30.054 26.6421 29.8164L43.8179 22.0223Z" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M44.9775 20.1787V32.1758" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.9854 25.1775V32.1758C12.9854 33.7667 14.2493 35.2924 16.4992 36.4174C18.7491 37.5423 21.8006 38.1743 24.9824 38.1743C28.1642 38.1743 31.2157 37.5423 33.4656 36.4174C35.7155 35.2924 36.9795 33.7667 36.9795 32.1758V25.1775" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">Training & Capacity Building</h3>
            <p className="mb-0 mt-3 gc2">Specialized training programs to enhance organizational capabilities. We develop and deliver customized training to build the skills and knowledge your team needs. </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Custom training curriculum development</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Workshops and seminars</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Simulation exercises</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">E-learning solutions</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Train-the-trainer programs</p>
            </div>
            <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
              <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 p-3 mt-lg-0 mt-3">
          <div className="p-4 d-flex flex-column wcc container-or-table3 int2">
            <div>
              <svg width="546" height="49" viewBox="0 0 546 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M32.9805 36.1748L44.9775 24.1777L32.9805 12.1807" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.9844 12.1807L4.9873 24.1777L16.9844 36.1748" stroke="#2C2F76" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h3 className="bc mb-0 mt-3 fw-bold">Digital Solutions</h3>
            <p className="mb-0 mt-3 gc2">Custom software and technology solutions for modern business challenges. Our digital solutions team designs and develops innovative tools to enhance your operations and security. </p>
            <div className="d-flex align-items-center mt-3">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Custom software development</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Mobile application development</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Web application development</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">E-System integration</p>
            </div>
            <div className="d-flex align-items-center mt-1">
              <p className="mb-0 bc fw-medium">•</p>
              <p className="mb-0 ms-2 blc">Digital transformation consulting</p>
            </div>
            <div className="d-flex bor b2 p-2 w-25 align-items-center mt-4">
              <p className="mb-0 fw-medium me-2 ps-2">Learn More</p>
              <div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33838 8H12.6694" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.00391 3.33447L12.6694 8L8.00391 12.6655" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default How